import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
} from "ui/components/sheet";
import { useFetch } from "@/hooks/useFetch";
import { fetchTimesheetEntry } from "@/modules/timesheet/api";
import { TimesheetViewSkeleton } from "@/modules/timesheet/logs/log/view/loader";
import { useNavigate, useParams } from "react-router-dom";
import TimesheetViewContent from "./timesheet-view-content";

export default function TimesheetViewSheet({
    timesheetId,
    open,
    onOpenChange,
    showEmployee = false,
}) {
    const { data, isLoading, isError } = useFetch({
        queryKey: ["timesheet", timesheetId],
        queryFn: () => fetchTimesheetEntry({ timesheetId }),
        enabled: !!timesheetId && open,
    });

    const handleOpenChange = (isOpen) => {
        if (onOpenChange) {
            onOpenChange(isOpen);
        }
    };

    return (
        <Sheet open={open} onOpenChange={handleOpenChange}>
            <SheetContent side="right" className="sm:max-w-3xl w-full overflow-y-auto">
                <SheetHeader>
                    <SheetTitle>Timesheet Entry</SheetTitle>
                </SheetHeader>
                {isLoading && <TimesheetViewSkeleton />}
                {isError && <div>Error loading timesheet entry</div>}
                {data && <TimesheetViewContent entryData={data} showEmployee={showEmployee} />}
            </SheetContent>
        </Sheet>
    );
}

export function TimesheetViewSheetWrapper({ showEmployee = false }) {
    const { timesheetId } = useParams();
    const navigate = useNavigate();

    return (
        <TimesheetViewSheet
            timesheetId={timesheetId}
            open={!!timesheetId}
            onOpenChange={(open) => {
                if (!open) {
                    navigate(-1);
                }
            }}
            showEmployee={showEmployee}
        />
    );
}

